import { uploadFile, uploadImagesForPointClouds, uploadVolumesForPointClouds } from "api/fileManager";

const fileUploaderApiConfig = {
  uploadFile,
  uploadImagesForPointClouds,
  uploadVolumesForPointClouds
};

export default fileUploaderApiConfig;